export const EVENT_TICKET_SALES_DEFAULT_INTENT = 'detail';
export const EVENT_TICKET_SALES_PLAYGUIDE_INTENT = 'playguide';
export const PLAYGUIDE_SETUP_SECTION_ID = 'playguide-setup';

type EventTicketSalesPathOptions = {
  setupPlayguide?: boolean;
};

export const buildEventTicketSalesPath = (
  eventUuid: unknown,
  { setupPlayguide = false }: EventTicketSalesPathOptions = {}
) => {
  const normalizedEventUuid = String(eventUuid || '').trim();
  if (!normalizedEventUuid) return '';

  const basePath = `/admin/workspaces/event-operations/events/${encodeURIComponent(normalizedEventUuid)}/ticket-sales`;
  return setupPlayguide ? `${basePath}?setup=playguide` : basePath;
};

export const isPlayguideSetupRequested = (search: unknown = '') => {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  return params.get('setup') === EVENT_TICKET_SALES_PLAYGUIDE_INTENT;
};
